import React, { useState } from "react";
import Card from "components/card";
import MessageCard from "./MessageCard";
import SearchBar from "components/search/SearchBar";
import MessageCardDetails from "./MessageCardDetails";

const MessagePanelList = ({ filteredMessages = [] }) => {
    const [searchKeyword, setSearchKeyword] = useState("");
    const [selectedMessage, setSelectedMessage] = useState(filteredMessages[0]);

    const handleSearch = ({ keyword }) => {
        setSearchKeyword(keyword.toLowerCase());
    };

    const filtered = filteredMessages.filter(msg =>
        msg.title?.toLowerCase().includes(searchKeyword.toLowerCase()) ||
        msg.department?.toLowerCase().includes(searchKeyword.toLowerCase()) ||
        msg.message?.toLowerCase().includes(searchKeyword.toLowerCase())
    );

    return (
        <>
            <Card className="flex flex-col gap-6 rounded-xl bg-white text-slate-900 border-2 border-slate-200 shadow-lg lg:col-span-1 overflow-hidden lg:block">
                <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 [.border-b]:pb-6 bg-gradient-to-br from-emerald-50 to-green-50 border-b p-3 sm:p-4">
                    <h4 className="text-[16px] sm:text-[18px]">My Messages</h4>
                    <p className="text-slate-700 text-[12px] sm:text-[14px]">
                        {filtered.length} message{filtered.length !== 1 ? "s" : ""}
                    </p>
                </div>
                <div className="pb-6 p-3 sm:p-4 space-y-3">
                    <SearchBar
                        placeholder="Search messages..."
                        searchHandler={handleSearch}
                        onChange={(e) => handleSearch(e.target.value)} 
                    />
                    <div className="bg-slate-200 shrink-0 h-px w-full"></div>
                    <div className="relative h-[400px] sm:h-[500px] lg:h-[600px] overflow-hidden">
                        <div className="h-full overflow-y-auto overscroll-contain scrollbar-hide">
                            <div className="space-y-2">
                                {filtered.map((msg, i) => (
                                    <MessageCard 
                                        key={i} 
                                        {...msg}
                                        selected={selectedMessage === msg}
                                        onClick={() => setSelectedMessage(msg)}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </Card>

            {selectedMessage && (
                <MessageCardDetails {...selectedMessage} />
            )}                 
        </>
    )
};
export default MessagePanelList;